import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';
import { Router } from '@angular/router';

@Injectable({
    providedIn: 'root',
})
export class ConnectivityService {
    private onlineStatusSubject = new BehaviorSubject<boolean>(navigator.onLine);

    constructor(private router: Router) {
        window.addEventListener('online', () => this.handleConnectionChange(true));
        window.addEventListener('offline', () => this.handleConnectionChange(false));
        if (!navigator.onLine) {
            this.router.navigate(['/no-connection']);
        }
    }

    private handleConnectionChange(isOnline: boolean) {
        this.onlineStatusSubject.next(isOnline);
        if (isOnline) {
            this.router.navigate(['/']);
        } else {
            this.router.navigate(['/no-connection']);
        }
    }

    get onlineStatus$(): Observable<boolean> {
        return this.onlineStatusSubject.asObservable();
    }
}
